module.exports = __webpack_public_path__ + "img/photo5.2fe022aa.png";